import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import DataTableSpecialiteMastere from "./DataTableEtudiantOrientation"
import AddSpecialiteMastere from "./AddEtudiantOrientation"
import DataTableMatiereSpecialite from "./DataTableEtudiantOrientation"
import AddMatiereSpecialite from "./AddEtudiantOrientation"
import DataTableMatiereOrientation from "./DataTableEtudiantOrientation"
import AddMatiereOrientation from "./AddEtudiantOrientation"
import DataTableEtudiantOrientation from "./DataTableEtudiantOrientation"
import AddSpecialiteOrientation from "../SpecialiteOrientation/AddSpecialiteOrientation"
import AddEtudiantOrientation from "./AddEtudiantOrientation"
const EtudiantOrientation = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    //
    // useEffect(async () => {
    //     var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
    //     setCloture(cloture_annee)
    //     const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    //     const typeArticleSubMenu = userAuth.find(user =>
    //         user.sous_menu.some(subMenu => subMenu.sous_menu === "Matière Spécialité")
    //     );
    //     setAdd(typeArticleSubMenu.sous_menu[3].add)
    //
    // }, [])
  useEffect(() => {
    const loadData = async () => {
      try {
        const cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee);

        const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || [];

        const typeArticleSubMenu = userAuth.find(
          user =>
            Array.isArray(user.sous_menu) &&
            user.sous_menu.some(
              subMenu => subMenu.sous_menu === "Etudiants Orientation"
            )
        )

        if (typeArticleSubMenu) {
          const menu = typeArticleSubMenu.sous_menu.find(
            subMenu => subMenu.sous_menu === "Etudiants Orientation"
          )

          if (menu) {
            setAdd(menu.add);
          }
        } else {
          console.warn("Le sous-menu 'Etudiants Orientation' est introuvable.")
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadData();
  }, []);
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
          return <DataTableEtudiantOrientation />
        } else if (section === 2) {
          return (
            <AddEtudiantOrientation setSection={setSection} back={back} />
          )
        }
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{props.t("Etudiant Orientation")} | Cresus </title>
          </MetaTags>
          <Container fluid>
            <div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 1,
                    })}
                    onClick={() => {
                      setSection(1)
                    }}
                  >
                    {props.t("Etudiant Orientation")}
                  </NavLink>
                </NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Traitement Etudiant Orientation")}
                </NavLink>
              </Nav>
              <Card>
                <CardBody>{renderBlock(section)}</CardBody>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
}

export default withRouter(withTranslation()(EtudiantOrientation))
EtudiantOrientation.propTypes = {
    t: PropTypes.any,
}
